<template>
  <customModal :containermd="true" @closeModal="closescheduleModal()">
    <template #title>
      Create Schedule
    </template>
    <template #body>
      <div class="schedule_modal__content p-3">
          <div class="row">
            <!-- Left Column -->
            <div class="col-md-6">
              <!-- CRA ID -->
              <div class="form-group">
                <label for="craid">CRA
                   <sup class="text-danger"><i class="fa fa-asterisk imp"></i></sup></label>
         
                <select class="form-control" id="craid" v-model="scheduleForm.craid" required>
                  <option value="">{{ $t("navigations.select") }}</option>
                  <option v-for="user in userList" :key="user.email" :value="user.email">
                    {{ user.email }}
                  </option>
                </select>
               </div>

              <!-- Site Code -->
              <div class="form-group">
                <label for="siteCode">{{ $t("navigations.site code") }}</label>
                <input type="text" class="form-control" id="siteCode" v-model="scheduleForm.siteCode" readonly  />
              </div>
               <div class="form-group">
          <label>Checklist</label>
          <Multiselect 
            v-model="scheduleForm.checklist" 
            mode="multiple" 
            :searchable="true"
            placeholder="Select Checklist items"
            :options="checklists" 
            :hideSelected="false"
            :closeOnSelect="false" 
            class="multiselect-theme">
          </Multiselect>
        </div>

              <!-- Planned Date -->
              <div class="form-group">
                <label for="plannedDate">{{ $t("navigations.planned date") }}</label>
                <input type="date" class="form-control" id="plannedDate" v-model="scheduleForm.plannedDate"  />
              </div>


               <!-- Triggered By -->
              <div class="form-group">
                <label for="triggeredBy">{{ $t("navigations.reason") }}</label>
                <select class="form-control" id="triggeredBy" v-model="scheduleForm.triggeredBy" required>
                  <option value="">{{ $t("navigations.select") }}</option>
                  <option v-for="trigger in triggeredByOptions" :key="trigger" :value="trigger">
                    {{ trigger }}
                  </option>
                </select>
              </div>
              
              <!-- Immediate Date -->
              <!-- <div class="form-group">
                <label for="immediateDate">{{ $t("navigations.immediate date") }}</label>
                <input type="date" class="form-control" id="immediateDate" v-model="scheduleForm.immediateDate" />
              </div> -->

           
            </div>

            <!-- Right Column -->
            <div class="col-md-6">
              <!-- CRA Visit Type -->
              <div class="form-group">
                <label for="craVisitType">{{ $t("navigations.visit type") }}</label>
                <select class="form-control"
          v-model="scheduleForm.craVisitTypeId"
          @change="onVisitTypeChange">

    <option value="">Select</option>

    <option v-for="type in visitTypes"
            :key="type.id"
            :value="type.id">

      {{ type.type }}

    </option>

      </select>

              </div>

              <!-- Visit Name -->
              <div class="form-group">
                <label for="visitName">{{ $t("navigations.visit name") }}</label>
                <input type="text" class="form-control" id="visitName" v-model="scheduleForm.visitName" />
              </div>

              <!-- Monitoring Mode -->
              <div class="form-group">
                <label for="monitoringMode">{{ $t("navigations.monitoring mode") }}</label>
                <select class="form-control" id="monitoringMode" v-model="scheduleForm.monitoringMode" required>
                  <option value="">{{ $t("navigations.select") }}</option>
                  <option v-for="mode in monitoringModeOptions" :key="mode" :value="mode">
                    {{ mode }}
                  </option>
                </select>
              </div>
              <div class="form-group">
          <label>Status</label>
          <select v-model="scheduleForm.status" class="form-control" >
            <option value="">Select</option>
            <option value="Planned">Planned</option>
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Rescheduled">Rescheduled</option>
            <option value="Overdue">Overdue</option>
          </select>
        </div>
              <!--  Comment box when Others is selected -->
             <div class="form-group mt-2" v-if="scheduleForm.triggeredBy === 'Others'">
                <label for="triggeredByComment">
                  Please specify the reason
                </label>
                <textarea id="triggeredByComment" class="form-control" rows="3"
                  v-model="scheduleForm.triggeredByComment" placeholder="Please specify the reason" required></textarea>
              </div>
              
            </div>
          </div>

          <!-- Buttons -->
          <div class="d-flex justify-content-end mt-3">
            <button type="button" class="cancel_btn py-1 px-4 mx-2" @click.prevent="closescheduleModal()">
              {{ $t("navigations.cancel") }}
            </button>
            <button type="submit" class="save_btn py-1 px-4" @click.prevent="submitSchedule()">
              {{ $t("navigations.save") }}
            </button>
          </div>
        </div>
    </template>
  </customModal>
</template>
<script src="./CreateSchedulePopup.js">
</script>
<style scoped>
</style>